import { formatDate, registerLocaleData } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import localeTh from '@angular/common/locales/th';

@Pipe({
  name: 'customThDate',
})
export class CustomThDatePipe implements PipeTransform {
  transform(
    value: string | number | Date | undefined,
    format: string,
    locale = 'th'
  ): string {
    if (!value) return '';

    registerLocaleData(localeTh);

    const date = new Date(value);
    const yearBE = date.getFullYear() + 543;
    let formatted = formatDate(date, format, locale); // format แบบอังกฤษก่อน

    // Thai short months
    const EN_MONTHS_SHORT = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    const TH_MONTHS_SHORT = [
      'ม.ค.',
      'ก.พ.',
      'มี.ค.',
      'เม.ย.',
      'พ.ค.',
      'มิ.ย.',
      'ก.ค.',
      'ส.ค.',
      'ก.ย.',
      'ต.ค.',
      'พ.ย.',
      'ธ.ค.',
    ];

    // แปลงชื่อเดือนย่อ (เฉพาะถ้ามี MMM)
    if (format.includes('MMM')) {
      const monthIndex = date.getMonth();
      formatted = formatted.replace(
        new RegExp(EN_MONTHS_SHORT[monthIndex], 'g'),
        TH_MONTHS_SHORT[monthIndex]
      );
    }

    // แปลงปี ค.ศ. เป็น พ.ศ.
    if (format.includes('yyyy')) {
      formatted = formatted.replace(
        date.getFullYear().toString(),
        yearBE.toString()
      );
    } else if (format.includes('yy')) {
      const adYY = date.getFullYear().toString().slice(-2);
      const beYY = yearBE.toString().slice(-2);
      formatted = formatted.replace(
        new RegExp(`${adYY}$`), // match เฉพาะท้าย string
        beYY
      );
    }

    return formatted;
  }
}
